import usersRepository from './usersRepository'
import parametersRespository from './parametersRespository'
import addressesRespository from './addressesRespository'
import personsRespository from './personsRespository'
import productsRepository from './productsRepository'
import sectionsRepository from './sectionsRepository'
import productCategoriesRepository from './productCategoriesRepository'
import productSubCategoriesRepository from './productSubCategoriesRepository'
import gameLinesRepository from './gameLinesRepository'
import gameExpansionsRepository from './gameExpansionsRepository'
import gameRaritiesRepository from './gameRaritiesRepository'
import cardsRepository from './cardsRepository'
import customersRepository from './customersRepository'
import ordersRepository from './ordersRepository'
import quotationsRepository from './quotationsRepository'
import shippingTypesRepository from './shippingTypesRepository'
import sliderImagesRepository from './sliderImagesRepository'
import bankAccountsRepository from './bankAccountsRepository'
import companyRepository from './companyRepository'
import invoiceParameterRepository from './invoiceParameterRepository'
import paymentMethodRepository from './paymentMethodRepository'
import credomaticRepository from './credomaticRepository'
import facturaPlusRepository from './facturaPlusRepository'

const repositories = {
    users: usersRepository,
    parameters: parametersRespository,
    addresses: addressesRespository,
    persons: personsRespository,
    products: productsRepository,
    sections: sectionsRepository,
    productCategories: productCategoriesRepository,
    productSubCategories: productSubCategoriesRepository,
    gameLines: gameLinesRepository,
    gameExpansions: gameExpansionsRepository,
    gameRarities: gameRaritiesRepository,
    cards: cardsRepository,
    customers: customersRepository,
    orders: ordersRepository,
    quotations: quotationsRepository,
    shippingTypes: shippingTypesRepository,
    sliderImages: sliderImagesRepository,
    bankAccounts: bankAccountsRepository,
    company: companyRepository,
    invoiceParameters: invoiceParameterRepository,
    paymentMethods: paymentMethodRepository,
    credomatic: credomaticRepository,
    facturaPlus: facturaPlusRepository,
}

export const repositoryFactory = {
    get: name => repositories[name],
}
